// src/app/questionare.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Questionare } from './objects/Questionare';
import { environment } from './environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QuestionareService {
  private apiUrl = environment.apiUrl + 'questionares';

  constructor(private http: HttpClient) {}

  getQuestionares(): Observable<Questionare[]> {
    return this.http.get<Questionare[]>(this.apiUrl);
  }

  getQuestionareById(id: number): Observable<Questionare> {
    return this.http.get<Questionare>(`${this.apiUrl}/${id}`);
  }

  addQuestionare(questionare: Questionare): Observable<Questionare> {
    return this.http.post<Questionare>(this.apiUrl, questionare);
  }

  updateQuestionare(id: number, questionare: Questionare): Observable<Questionare> {
    return this.http.put<Questionare>(`${this.apiUrl}/${id}`, questionare);
  }

  deleteQuestionare(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
